<template>
  <div>
    <div class="invite-card" v-for="item in data" :key="item.id">
      <div class="card-title">
        <span class="line"></span>
        <span class="title">{{formateDateTime(item.dateStr)}} {{item.appointTime}}</span>
      </div>
      <div class="card-content" v-if="item.exhibitorDTO">
        <div class="content-left">
          <img class="img" :src="item.exhibitorDTO.logoImage || 'https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/tangjiu/113/invite-default-avatar.png'" alt="">
        </div>
        <div class="content-right">
          <div class="name">{{ item.exhibitorDTO.name}}</div>
          <div class="content-info-item">
            <div class="label lb1">展位号：</div>
            <div class="value">{{item.exhibitorDTO.exhibitionExhibitorDTO && item.exhibitorDTO.exhibitionExhibitorDTO.exhibitionBoothNumber}}</div>
          </div>
          <div class="content-info-item">
            <div class="label lb1">联系人：</div>
            <div class="value">
              <span>阳刚</span>
              <span class="sign">销售经理</span>
            </div>
          </div>
          <div class="content-info-item">
            <div class="label lb2">洽谈方式：</div>
            <div class="value">
              <span class="tag">{{formatAddress(item)}}</span>
            </div>
          </div>
          <div class="content-info-item">
            <div class="label lb2">洽谈主题：</div>
            <div class="value">{{item.appointTheme || '洽谈主题'}}</div>
          </div>
        </div>
      </div>

      <div class="invite-sure" v-if="active === 1 && subjectType !== 'VISITOR'">接受预约</div>
    </div>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex'

  export default {
    props: {
      active: {
        type: Number,
        default: 0
      },
      data: {
        type: Array,
        default: () => []
      }
    },
    data() {
      return {
      }
    },
    computed: {
      ...mapGetters(['subjectType'])
    },
    methods: {
      formateDateTime(dateStr) {
        return dateStr ? this.$dayjs(dateStr).format('YYYY年MM月DD日') : ""
      },
      formatAddress(item) {
        if (item.appointPlaceId === "d33549020c0c73d4a3bf040363f70c8d") {
          return '洽谈区'
        } else {
          return item.appointPlace
        }
      },
    }
  }
</script>

<style lang="scss" scoped>
  .invite-card {
    padding: 12px;
    background: #ffffff;
    border-radius: 12px;
    margin-bottom: 12px;
    .card-title {
      display: flex;
      align-items: center;
      .line {
        display: inline-block;
        width: 3px;
        height: 16px;
        background: #EA592A;
        margin-right: 6px;
      }
      .title {
        font-weight: 400;
        font-size: 14px;
        color: #666666;
      }
    }
    .card-content {
      width: 100%;
      display: flex;
      margin-top: 12px;
      .content-left {
        width: 50px;
        height: 50px;
        border-radius: 8px;
        overflow: hidden;
        .img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }
      .content-right {
        flex: 1;
        padding-left: 12px;
        box-sizing: border-box;
        padding-top: 4px;
        overflow: hidden;
        .name {
          font-weight: 600;
          font-size: 14px;
          color: #333333;
        }
        .content-info-item {
          margin-top: 8px;
          display: flex;
          align-items: baseline;
          flex-wrap: wrap;
          word-break: break-word;
          .label {
            font-weight: 400;
            font-size: 12px;
            color: #666666;
            &.lb1 {
              width: 49px;
            }
            &.lb2 {
              width: 62px;
            }
          }
          .value {
            flex: 1;
            font-weight: 500;
            font-size: 12px;
            color: #666666;
            .sign {
              padding-left: 5px;
              margin-left: 5px;
              border-left: 1px solid #D9D9D9;
            }
            .tag {
              background: #FFF8F5;
              border-radius: 4px;
              padding: 3px 8px;
              font-weight: 400;
              font-size: 12px;
              color: #FF5518;
            }
          }
        }
      }
    }
    .invite-sure {
      margin-top: 12px;
      padding: 7px 0;
      font-weight: 500;
      font-size: 14px;
      color: #EA592A;
      text-align: center;
      background: #FFFFFF;
      border-radius: 50px;
      border: 1px solid #EA592A;
    }
  }
</style>